var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  height: 40,
  viewBox: "0 0 40 40",
  width: 40,
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#0e98dd",
  height: 40,
  rx: 20,
  width: 40
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M14.455 11.78h11.089c.697 0 1.288 0 1.756.042.472.043.986.14 1.422.46a2.6 2.6 0 0 1 1.051 1.85c.052.537-.128 1.03-.332 1.457-.202.423-.505.932-.861 1.53l-7.721 12.972a1 1 0 0 1-1.719 0L11.42 17.12c-.357-.6-.66-1.108-.862-1.531-.204-.428-.384-.92-.332-1.457a2.6 2.6 0 0 1 1.051-1.85c.436-.32.95-.417 1.422-.46.468-.043 1.06-.043 1.756-.043zm-1.997 2.116a.6.6 0 0 0-.241.425c0 .007.003.108.146.406.158.33.412.76.799 1.41L19 25.944V13.78h-4.497c-.758 0-1.256.001-1.62.035-.33.03-.419.079-.425.082zM21 13.78v12.165l5.838-9.807c.387-.65.641-1.08.8-1.41.142-.298.145-.4.145-.406a.6.6 0 0 0-.241-.425c-.006-.004-.095-.052-.424-.082-.365-.034-.863-.035-1.62-.035z",
  fill: "#fff",
  fillRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTon);
export { ForwardRef as ReactComponent };